import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import Breadcrumb from '../components/Breadcrumb';
import ProductPageComponent from '../components/ProductPage';
import { genCategoryUrl } from '../utils/urls';

const ProductPage = ({ data, pageContext }) => {
    const { category, product } = data;
    const { productSpecDetail, specPdfLink } = pageContext;

    if (productSpecDetail) {
        product.productSpecDetail = productSpecDetail;
        product.specPdfLink = specPdfLink;
    }

    const breads = [
        { to: '/products', name: '產品列表' },
        {
            name: category.name,
            to: genCategoryUrl(category.url),
        },
        { name: product.name },
    ];

    return (
        <Layout pageContext={pageContext}>
            <Breadcrumb breads={breads} />
            <ProductPageComponent {...product} />
        </Layout>
    );
};

export default ProductPage;

export const productItemPageQuery = graphql`
    query ProductItemPage($contentfulId: String!, $categoryId: String!) {
        product: contentfulProducts(contentful_id: { eq: $contentfulId }) {
            seo_desc
            name
            url
            desc {
                desc
            }
            images {
                fluid(maxWidth: 1000, quality: 100) {
                    ...GatsbyContentfulFluid_withWebp
                }
                fixed(width: 400) {
                    ...GatsbyContentfulFixed_withWebp
                }
            }
            spec {
                spec
            }
            certificate {
                certificate
            }
            feature {
                feature
            }
            tags {
                url
                name
            }
        }
        category: contentfulCategory(contentful_id: { eq: $categoryId }) {
            url
            name
        }
    }
`;
